"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesTransactionSchema = exports.INVESTMENT_AMOUNT_MIN = exports.INVESTMENT_AMOUNT_MAX = void 0;
const moment_1 = __importDefault(require("moment"));
const yup = __importStar(require("yup"));
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const constants_1 = require("../constants");
exports.INVESTMENT_AMOUNT_MAX = "Investment Amount can not exceed $99,999,999,999.99";
exports.INVESTMENT_AMOUNT_MIN = "Investment amount should be at least $1.00";
exports.NotesTransactionSchema = yup.object().shape({
    status: yup
        .string()
        .when("$isDollar", ([isDollar], schema) => isDollar ? schema.notRequired().nullable() : schema.required().oneOf(["issue", "transfer"])),
    notesId: yup.string().required("Please select a name"),
    investmentAmount: yup.lazy((investmentAmount) => investmentAmount === ""
        ? yup.string().required("Face value can not be empty")
        : yup
            .number()
            .required()
            .when("$isDollar", ([isDollar], schema) => isDollar
            ? schema.min(1.0, exports.INVESTMENT_AMOUNT_MIN).max(99999999999.99, exports.INVESTMENT_AMOUNT_MAX)
            : schema.min(100.0, exports.INVESTMENT_AMOUNT_MIN).max(9999999999999.99, exports.INVESTMENT_AMOUNT_MAX))),
    issueDate: yup
        .string()
        .required(constants_1.DATE_REQUIRED)
        .test("issueDate", constants_1.DATE_VALID, (issueDate) => (0, moment_1.default)(issueDate).isValid() && (0, mystake_common_sdk_1.getDateYear)(issueDate) > 1920)
        .test("dateOfIssue", constants_1.DATE_VALID, (issueDate) => (0, moment_1.default)(issueDate).isValid()),
    maturityDate: yup
        .string()
        .when("$isDollar", ([isDollar], schema) => isDollar
        ? schema.notRequired().nullable()
        : schema.nullable().test("maturityDate", constants_1.DATE_VALID, (maturityDate) => (0, moment_1.default)(maturityDate).isValid())),
});
//# sourceMappingURL=NotesTransactionSchema.js.map